import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Collections} from "components";

const breadcrumbStatic = [{
	name: 'FE Graph Floors',
	url: '/admins/fe_metric_thresholds',
	icon: 'dashboard'
}];

export default class Fe_Metric_Thresholds extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar breadcrumbs={breadcrumbStatic} history={this.props.history}/>
				<Collections.FeMetricThresholds/>
			</div>
		);
	}
}
